export default __webpack_public_path__ + "static/media/github.1276453d.jpg";